var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rt-editor",class:{ 'rt-editor--readonly': _vm.readonly }},[(_vm.editor)?_c('editor-content',{staticClass:"rt-content",attrs:{"editor":_vm.editor}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }